import * as React from 'react';
import { observer } from 'mobx-react';
import { Dropdown } from '@shared/ui-react/Dropdown';
import { DocumentsImagesStoreAbstract } from '@shared/documents-images/DocumentsImagesStoreAbstract';
import { Button } from '@shared/ui-react/Button';
import { Events, EventsGlobal } from '@shared/Events';
import { Telemetry, TelemetryEventType, TelemetrySource } from '@shared/Telemetry';

@observer
export class ImagesPanelToolbar extends React.Component<{
    store: DocumentsImagesStoreAbstract<any>;
    onBulkEdit: () => void;
    onOpenUploader: () => void;
}> {
    dlButtonRef;
    dropdownEl: Dropdown = null;

    render() {
        const canEdit = kuura.hasPrivilege('PROJECT_W');
        const canDownload = kuura.hasPrivilege('Download_Image');

        return (
            <>
                <Button
                    secondary
                    subtle
                    icon='iki-fit-to-screen'
                    style={{ marginLeft: 'auto' }}
                    onClick={() => {
                        Events.trigger(EventsGlobal.MAP_FIT_PHOTOS);
                        Telemetry.add(TelemetryEventType.MAP_IMAGES_FIT_VIEW, TelemetrySource.MAP_2D_DESKTOP);
                    }}
                    title={__('js_map.fit_visible')}
                />

                <Dropdown ref={el => (this.dropdownEl = el)} buttonStyle={{ paddingLeft: 10, paddingRight: 10 }} className='ik-button-secondary--subtle'>
                    <i ref={e => (this.dlButtonRef = e)} className='iki iki-more' />
                    <div className='no-select'>
                        {kuura.hasPrivilege('PROJECT_W') && (this.props.onBulkEdit || this.props.onOpenUploader) && (
                            <>
                                <div className='dropdown-list-title'>{__('general.actions')}:</div>
                                <ul className='dropdown-list clickable' onClick={() => this.dropdownEl.close(true)}>
                                    {this.props.onBulkEdit && (
                                        <li
                                            onClick={() => {
                                                Telemetry.add(TelemetryEventType.MAP_IMAGES_BULK_EDIT, TelemetrySource.MAP_2D_DESKTOP);
                                                this.props.onBulkEdit();
                                            }}
                                        >
                                            <i className='iki iki-area'></i>
                                            <span>{__('js_map.bulk_edit')}</span>
                                        </li>
                                    )}
                                    {this.props.onOpenUploader && (
                                        <li onClick={this.props.onOpenUploader}>
                                            <i className='iki iki-upload' /> {__('js_files.upload_btn')}
                                        </li>
                                    )}
                                </ul>
                            </>
                        )}

                        {canDownload && (
                            <>
                                <div className='dropdown-list-title'>{__('general.download')}:</div>
                                <ul className='dropdown-list clickable' onClick={() => this.dropdownEl.close(true)}>
                                    <li className='js-images-panel-dl-visible' onClick={this.downloadVisible}>
                                        {__('js_images.download_shown_on_map')}
                                    </li>
                                    <li className='js-images-panel-dl-all' onClick={this.downloadAll}>
                                        {__('js_images.download_all_with_folder_structure')}
                                    </li>
                                    <li onClick={this.downloadXls}>{__('js_images.download_images_summary_excel')}</li>
                                </ul>
                            </>
                        )}

                        <div className='dropdown-list-title'>{__('general.icon_size')}:</div>
                        <ul className='dropdown-list clickable'>
                            <li onClick={() => this.setIconScale(1)}>
                                <input type='radio' checked={this.props.store.iconScale == 1} readOnly />
                                {__('general.size.normal')}
                            </li>
                            <li onClick={() => this.setIconScale(1.35)}>
                                <input type='radio' checked={this.props.store.iconScale == 1.35} readOnly />
                                {__('general.size.large')}
                            </li>
                        </ul>

                        <div className='dropdown-list-title'>{__('general.sort')}:</div>
                        <ul className='dropdown-list clickable'>
                            <li onClick={() => this.setSort('date')}>
                                <input type='radio' checked={this.props.store.sortKey == 'date'} readOnly />
                                {__('general.date')}
                            </li>
                            <li onClick={() => this.setSort('station')}>
                                <input type='radio' checked={this.props.store.sortKey == 'station'} readOnly />
                                {__('js_vehicles.station')}
                            </li>
                            <li onClick={() => this.setSort('name')}>
                                <input type='radio' checked={this.props.store.sortKey == 'name'} readOnly />
                                {__('general.name')}
                            </li>
                        </ul>
                    </div>
                </Dropdown>
            </>
        );
    }

    setSort(sort: 'name' | 'date' | 'station') {
        this.props.store.sortKey = sort;
    }

    setIconScale(scale: number) {
        this.props.store.iconScale = scale;
    }

    downloadVisible = () => {
        const btn = $(this.dlButtonRef.parentElement);
        btn.loading(true);
        this.props.store.downloadFiltered().always(() => btn.loading(false));
    };

    downloadAll = () => {
        const btn = $(this.dlButtonRef.parentElement);
        btn.loading(true);
        this.props.store.downloadByIds(null, null).always(() => btn.loading(false));
    };

    downloadXls = () => {
        window.open('/kuura/api/1/project/' + kuura.getProjectId() + '/images_summary.xlsx', '_blank').focus();
    };
}
